import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vSelect from 'vue-select';

export default Vue.component('edit-place-cards', {
  template: require('./template.html'),
  name: 'edit-place-cards',
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters(['currentSite']),
    noDynamicData() {
      const hasDynamic = this.currentSite.dynamic;
      return !hasDynamic || (hasDynamic && !this.currentSite.dynamic.places);
    },
    sortKeyOptions() {
      return [
        {
          label: 'Published Date',
          value: 'publisheOn',
        },
        {
          label: 'Name',
          value: 'name',
        },
      ];
    },
    sortByLabel() {
      let normal = 'Newest';
      let reverse = 'Oldest';
      const sortKey = this.droplet.sortKey;
      if ((typeof sortKey === 'string' && sortKey === 'name') ||
          (_.isPlainObject(sortKey) && sortKey.value === 'name')) {
        normal = 'Alphabetical';
        reverse = 'Reverse Alphabetical';
      }
      return { normal, reverse };
    },
    categoryOptions() {
      let list = [];
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic.places;
      if (enabled) {
        list = enabled.categories;
      }
      return list;
    },
  },
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      bounceTime: null,
      display: {
        customList: false,
        hideFilters: false,
        paginate: 0,
        customCategories: null,
        sortKey: false,
        filterText: false,
        map: false,
        placeholder: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.customList = this.droplet.customList;
      this.display.hideFilters = this.droplet.hideFilters;
      this.display.paginate = this.droplet.paginate;
      this.display.customCategories = _.clone(this.droplet.customCategories);
      this.display.filterText = this.droplet.filterText || '';
      this.display.placeholder = this.droplet.placeholder || '';
      this.display.map = this.droplet.map;
      const sortKey = this.droplet.sortKey;
      if (typeof sortKey === 'string') {
        this.display.sortKey = { label: _.startCase(sortKey), value: sortKey };
      } else {
        this.display.sortKey = _.clone(sortKey);
      }
    },
    setPagination() {
      this._debounce(() => {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          val: this.display.paginate,
          key: 'paginate',
        });
        this.bouncePlugin();
      }, 250);
    },
    updateCustomList() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.customList,
        key: 'customList',
      });
      this.bouncePlugin();
    },
    updateHideFilters() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.hideFilters,
        key: 'hideFilters',
      });
      this.bouncePlugin();
    },
    updateMap() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.map ? {
          title: 'name',
          pin: 'mapPin',
        } : false,
        key: 'map',
      });
      this.bouncePlugin();
    },
    selectCategory(list) {
      if (list) {
        const val = _.clone(list);
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'customCategories',
          val,
        });
        this.bouncePlugin();
      }
    },
    updateSortKey(key) {
      let bounce;
      if (key) {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          val: _.clone(key),
          key: 'sortKey',
        });
        bounce = true;
      } else if (_.isNull(key)) {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          val: {
            label: 'Published Date',
            value: 'publisheOn',
          },
          key: 'sortKey',
        });
        bounce = true;
      }
      if (bounce) {
        this.bouncePlugin();
      }
    },
    radioUpdate(val, key) {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key,
        val,
      });
      this.bouncePlugin();
    },
    updateFilterText() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.filterText,
        key: 'filterText',
      });
      this._debounce(() => {
        this.bouncePlugin();
      }, 300);
    },
    bouncePlugin() {
      this.$vnode.context.destroyPlugin();
      clearInterval(this.bounceTime);
      this.bounceTime = setTimeout(() => {
        this.$vnode.context.initPlugin();
      }, 250);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/place-cards/components/_edit-options/index.js